import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuFormlyBuilder } from '../formly.builder';
import { FieldType, InputType } from './formly-builder.models';

export class LuChipBuilder extends LuFormlyBuilder {
	protected type: FieldType = FieldType.LU_CHIP;
	private inputType: InputType = InputType.TEXT;

	public setInputType(inputType: InputType): this {
		this.inputType = inputType;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();

		// Patch
		// addedValues in some edge cases is null and selection limit validation fails
		// eg. Dynamic rules email chip validation
		field.templateOptions.addedValues = [];
		field.templateOptions.type = this.inputType;

		return field;
	}
}
